import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

import { Guide } from '@model';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class GuidesService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getGuides(): Observable<Guide[]> {
    return this.http
      .get<Guide[]>(`${environment.apiEndpoint}/Help/Guides`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
